// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M20 3V2H22V22H13V15H11V22H2V2H4V3H8V2H10V9.13148L12 7.79815L14 9.13148V2H16V3H20ZM8 5H4V20H6V10H8V5ZM16 10H18V20H20V5H16V10Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-castle-5-filled')
export default class Castle5FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'castle-5-filled',
    }
  }
}
